import { GeralService } from '@gestor-web/app/shared/services';
import { GuiaGridRowBase, TipoGuiaDomain } from './guias-grid.types';

export interface GuiaGridMapperOptions {
  tipoGuiaDomain?: TipoGuiaDomain;
}

export function mapGuiaRowWithDomains<TRow extends GuiaGridRowBase>(
  item: TRow,
  geralService: GeralService,
  options?: GuiaGridMapperOptions,
): TRow & GuiaGridRowBase {
  const row: TRow & GuiaGridRowBase = { ...item };
  const tipoGuiaDomain = options?.tipoGuiaDomain ?? 'MON_TIPO_GUIA';

  row.nm_id_cnpj_cpf_exec = geralService.buildNomeDeDominio(row.id_cnpj_cpf_exec, 'MON_ID_CNPJ_CPF');
  row.nm_tp_guia = geralService.buildNomeDeDominio(row.tp_guia, tipoGuiaDomain);
  row.nm_tp_rede = geralService.buildNomeDeDominio(row.tp_rede, 'MON_TIPO_REDE');
  row.nm_id_origem_guia = geralService.buildNomeDeDominio(row.id_origem_guia, 'dm_origemEventoAtencaoSaude');

  if (row.tp_registro !== undefined) {
    row.nm_tp_registro = geralService.buildNomeDeDominio(row.tp_registro, 'dm_statusTransacaoMonitor');
  }

  if (row.tp_atendimento !== undefined) {
    row.nm_tp_atendimento = geralService.buildNomeDeDominio(row.tp_atendimento, 'dm_tipoAtendimento');
  }

  if (row.id_regime_atendimento !== undefined) {
    row.nm_id_regime_atendimento = geralService.buildNomeDeDominio(row.id_regime_atendimento, 'dm_regimeAtendimento');
  }

  if (row.st_guia_ans !== undefined) {
    row.nm_st_guia_ans = geralService.buildNomeDeDominio(row.st_guia_ans, 'MON_GUIA_SITUACAO_ANS');
  }

  return row;
}
